import AnimatedPage from '../components/animatedPage'
import Banner from '../components/banner/banner'
import { DecodeHtml } from '../utils/decodeHtml'
import { retrunAssets, returnNotImage } from '../utils/getAssets'
import useFetch from '../utils/useFetch'

const BemGap = () => {
  const data = useFetch('training-services/bem-gap/')
  const bemGap = data?.properties
  const title = bemGap?.title
  const bg =
    bemGap?.backgroundImage !== null
      ? retrunAssets(bemGap?.backgroundImage[0]?.url)
      : returnNotImage()
  const button1 =
    bemGap?.buttonLabel?.items != null
      ? bemGap?.buttonLabel?.items[0]?.content?.properties
      : null
  const button2 =
    bemGap?.buttonLabel?.items != null
      ? bemGap?.buttonLabel?.items[1]?.content?.properties
      : null
  return (
    <AnimatedPage>
      <Banner text={title} bg={bg} />
      <div className='flex justify-center flex-col gap-10 w-full p-8 md:p-12'>
        <div className='flex flex-col gap-3'>
            <h1 className='whitespace-pre-line heading'>
                {DecodeHtml({html:bemGap?.mainRichText?.markup})}
            </h1>

        </div>


        <div className='grid grid-cols-1 sm:grid-cols-2 gap-5'>
          <div className='bg-[#add8e6] min-h-[190px] rounded p-4 flex flex-col justify-between gap-8'>
            <h1 className='text-3xl max-w-sm font-normal'>{button1?.label}</h1>
            <a
              href={button1?.link}
              className='py-2 px-3 text-sm rounded bg-[#f8f9fa] w-fit'
            >
              Click to Apply
            </a>
          </div>
          <div className='bg-[#ffa07a] min-h-[190px] rounded p-4 flex flex-col justify-between gap-8'>
            <h1 className='text-3xl max-w-sm font-normal'>{button2?.label}</h1>
            <a
              href={button2?.link}
              className='py-2 px-3 text-sm rounded bg-[#f8f9fa] w-fit'
            >
              Click to Apply
            </a>
          </div>
        </div>

        <div className='grid grid-cols-1 md:grid-cols-2 gap-5 whitespace-pre-line'>
          {DecodeHtml({ html: bemGap?.leftRichText?.markup })}
          {DecodeHtml({ html: bemGap?.rightRichText?.markup })}
        </div>
      </div>
    </AnimatedPage>
  )
}

export default BemGap
